import { EllipsisVertical } from "lucide-react";
import React, { MouseEvent } from "react";
import { useImmer } from "use-immer";

import { IgIconButton, IgTypography } from "@intelligems/ig-theme";
import { Grid, Menu, MenuItem } from "@mui/material";

interface MoreMenuArchivedSubpageProps {
  onCopyClick: () => void;
}

export const MoreMenuArchiveSubpage = ({
  onCopyClick,
}: MoreMenuArchivedSubpageProps) => {
  const [anchorEl, setAnchorEl] = useImmer<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Grid container width={"fit-content"}>
      <IgIconButton
        id="more-button"
        aria-controls="more-positioned-menu"
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        disableRipple
        sx={{
          padding: "0px",
          justifyContent: "flex-end",
          maxWidth: "20px",
        }}
        onClick={handleClick}
      >
        <EllipsisVertical size={18} />
      </IgIconButton>
      <Menu
        id="more-positioned-menu"
        aria-labelledby="more-positioned-button"
        disablePortal
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuItem onClick={onCopyClick}>
          <IgTypography>Make a copy</IgTypography>
        </MenuItem>
        <MenuItem onClick={handleClose}>Close</MenuItem>
      </Menu>
    </Grid>
  );
};
